import { focusOutline } from 'shared/assets/styles';
import { Colors } from 'shared/components/ui/checkbox';
import { getCheckboxBorderColor } from 'shared/components/ui/checkbox/checkbox.style';
import styled, { css, DefaultTheme } from 'styled-components';

// A task with neither a color nor a priority resolves to `Colors.Default`, which the
// checkbox paints `primary.main` — as loud on an uncolored card as a real category color.
// The badge stays grey there and only takes the checkbox's color once there is one.
const getBadgeColor = (theme: DefaultTheme, color?: Colors | string) =>
  !color || color === Colors.Default
    ? theme.palette.grey[700]
    : getCheckboxBorderColor(color, theme);

// Unsynced badges are hover-only: the reveal lives on the event card's Container
// (event.style.ts), which is the element the pointer actually hovers. Focus
// reveals it too so the button isn't tabbable-but-invisible.
export const Badge = styled.button<{
  $synced: boolean;
  $color?: Colors | string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  margin: ${({ theme }) => theme.spacing(1)};
  padding: 0;

  border: none;
  background: none;
  cursor: pointer;

  color: ${({ theme, $color }) => getBadgeColor(theme, $color)};

  ${({ $synced }) =>
    !$synced &&
    css`
      opacity: 0;
    `};

  &:focus-visible {
    ${focusOutline};
    opacity: 1;
  }
`;
